module.exports = __webpack_public_path__ + "img/第6章_1-4_平行世界圖表1-2.jpg";